module.exports = __webpack_public_path__ + "static/yagmur-pinduk-b4a9d77ed0b7e0a337707dff4ce917a9.webp";